<template>
  <div class="user clearfix">
    <!--添加补单类别-->
    <div class="common-level-rail fl">
      <el-button
        size="small"
        type="primary"
        icon="el-icon-plus"
        @click="addClick"
        >添加补单类别</el-button
      >
    </div>
    <div class="product-content">
      <div class="table-wrap">
        <el-table
          size="small"
          :data="tableData"
          row-key="id"
          default-expand-all
          :tree-props="{ children: 'child' }"
          style="width: 100%"
          v-loading="loading"
        >
          <el-table-column
            prop="name"
            label="补单分类"
            width="180"
          ></el-table-column>
          <el-table-column
            prop="create_time"
            label="添加时间"
          ></el-table-column>
          <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <el-button @click="editClick(scope.row)" type="text" size="small"
                >编辑</el-button
              >
              <el-button
                @click="deleteClick(scope.row)"
                type="text"
                size="small"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!--添加-->
    <Add
      v-if="open_add"
      :open_add="open_add"
      :addform="categoryModel"
      @closeDialog="closeDialogFunc($event, 'add')"
    ></Add>
    <!--修改-->
    <Edit
      v-if="open_edit"
      :open_edit="open_edit"
      :editform="categoryModel"
      @closeDialog="closeDialogFunc($event, 'edit')"
    ></Edit>
  </div>
</template>

<script>
import OrderApi from "@/api/order.js";
import Add from "./Add.vue";
import Edit from "./Edit.vue";
export default {
  components: {
    Add,
    Edit
  },
  data() {
    return {
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      loading: false,
      /*列表数据*/
      tableData: [],
      /*当前编辑的对象*/
      categoryModel: {
        catList: [],
        model: {}
      }
    };
  },
  created() {
    this.getData();
  },
  methods: {
    // 添加补单类别
    addClick() {
      // 打开弹出框
      this.open_add = true;
    },
    // 获取补单类别列表
    getData() {
      let self = this;
      OrderApi.repairOrderType().then(res => {
        self.loading = false;
        self.tableData = res.data;
        self.categoryModel.catList = self.tableData;
      });
    },
    // 添加补单类别
    addSupplier() {
      let parmas = {
        pid: "",
        id: 0
      };
      OrderApi.addRepairOrderType(params, true).then(res => {
        console.log(res);
      });
    },
    /*打开编辑*/
    editClick(item) {
      console.log("object", item)
      this.categoryModel.model = item;
      this.open_edit = true;
    },
    // 查询
    onSubmit() {
      console.log("submit!");
    },
    closeDialogFunc(e, f) {
      if (f == "add") {
        this.open_add = e.openDialog;
        if (e.type == "success") {
          this.getData();
        }
      }
      if (f == "edit") {
        this.open_edit = e.openDialog;
        if (e.type == "success") {
          this.getData();
        }
      }
    },
    /*删除用户*/
    deleteClick(row) {
        let self = this;
        self.$confirm('此操作将永久删除该类别, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          self.loading = true;
          OrderApi.delRepairOrderType({
              id: row.id
            }, true).then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.getData();
            })
            .catch(error => {
              self.loading = false;
            });

        }).catch(() => {});
      }
  }
};
</script>

<style lang="scss" scoped>
.user {
  padding: 20px;
  .common-level-rail {
    margin-bottom: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/order/supplement/index.vue